
const SideMenuItems = [
    {
        name: "Home",
        route: "home",
        isSubMenu:false,
        isBusRoute:true,
        isAdminRoute:true,
        isPRAdminRoute:true,
        subRoutes:['']
    },
    {
        name: "Dashboard",
        route: "dashboard",
        isSubMenu:false,
        isBusRoute:true,
        isAdminRoute:true,
        isPRAdminRoute:true,
        subRoutes:['']
    },
    {
        name: "Gallery",
        route: "gallery",
        isSubMenu:false,
        isBusRoute:true,
        isAdminRoute:true,
        isPRAdminRoute:true,
        subRoutes:['']
    },
    {
        name: "Business Units & Locations",
        route: "business-units",
        subRoutes: ["create-businessunit", 'edit-businessunit','view-businessunit'],
        isSubMenu: true,
        isBusRoute:false,
        isPRAdminRoute:true,
        isAdminRoute:true,
    },
    {
        name: "User Management",
        route: "user-management",
        isSubMenu: true,
        subRoutes:["user-management","create-user","edit-user", "view-user"],
        isBusRoute:false,
        isPRAdminRoute:true,
        isAdminRoute:true,
    },
    {
        name: "Charitable Activities",
        route: "charitable-activity",
        isSubMenu: true,
        subRoutes: ["create-charitable-activity", 'edit-charitable-activity', 'view-charitable-activity'],
        isBusRoute:true,
        isPRAdminRoute:true,
        isAdminRoute:true,
    }, {
        name: "Audit Log",
        route: "audit-log",
        isSubMenu: true,
        subRoutes: [],
        isBusRoute:false,
        isPRAdminRoute:true,
        isAdminRoute:true,
    },
    {
        name: "User Manual",
        route: "user-manual",
        isSubMenu: false,
        subRoutes: [],
        isBusRoute:true,
        isPRAdminRoute:true,
        isAdminRoute:true,
    }

];

export default SideMenuItems;
